import React, { useState, useEffect } from "react";
import { PatternFormat } from "react-number-format";
import { validCPF, validCNPJ } from "../../hooks/utils/useFormat";
import { toast } from "react-toastify";

const InputDocument = props => {
  const { type, value, valueChange, disabled, required } = props;
  const _pattern =
    type === "cpf"
      ? {
          placeholder: "***.***.***-**",
          format: "###.###.###-##",
          length: 11,
        }
      : type === "cnpj"
      ? {
          placeholder: "***.***.***/****-**",
          format: "###.###.###/####-##",
          length: 15,
        }
      : null;
  const [isValid, setisValid] = useState(false);
  const invalidate = () => {
    setisValid(false);
    return false;
  };

  useEffect(() => {
    if (value) {
      (() => {
        let _value = value.replace(/[^0-9]/g, "");
        let _is_valid = String(_value || 0)?.length === _pattern?.length;
        if (!_is_valid) return invalidate();
        if ((type === "cpf" && !validCPF(_value)) || (type === "cnpj" && !validCNPJ(_value))) {
          toast.error("CPF Inválido.", { toastId: "document_error" });
          return invalidate();
        }
        setisValid(true);
      })();
    }
  }, [value]);

  return (
    <PatternFormat
      data-required={required}
      data-required-valid={required && !!isValid}
      disabled={disabled}
      placeholder={_pattern?.placeholder}
      format={_pattern?.format}
      value={!value ? "" : value}
      onValueChange={__ev => {
        valueChange(String(__ev.value));
        if ((type === "cpf" && validCPF(__ev.value)) || (type === "cnpj" && validCNPJ(__ev.value))) {
          setisValid(true);
        }
      }}
      onKeyPress={__ev => {
        __ev.key === "Enter" && __ev.target.blur();
      }}
      {...props}
    />
  );
};

export default InputDocument;
